import { render } from "./AppTile.vue?vue&type=template&id=1ef03a2c&scoped=true&ts=true"
import script from "./AppTile.vue?vue&type=script&lang=ts"
export * from "./AppTile.vue?vue&type=script&lang=ts"

import "./AppTile.vue?vue&type=style&index=0&id=1ef03a2c&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef03a2c"]])

export default __exports__